import { Vue } from 'vue-property-decorator'

export const templateImageType = () => {
  return {
    HEADER: { key: 50480001, label: Vue.prototype.$gettext('TEMPLATE_IMAGE_TYPE.50480001') },
    FOOTER: { key: 50480002, label: Vue.prototype.$gettext('TEMPLATE_IMAGE_TYPE.50480002') },
    BODY: { key: 50480003, label: Vue.prototype.$gettext('TEMPLATE_IMAGE_TYPE.50480003') },
    THUMBNAIL: { key: 50480004, label: Vue.prototype.$gettext('TEMPLATE_IMAGE_TYPE.50480004') }
  }
}
